<template>
  <div>
    <div v-if="userState === 'auth'">
      <p>user docs</p>
      <div v-for="(doc, index) in userDocs" :key="index + 'doc'">
        <a href="#" @click.prevent="showDoc(index)">{{ doc.document_topic }}</a>
      </div>
    </div>
    <div v-else>
      <p>not user information</p>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  name: "user_docs",
  data() {
    return {
      userDocs: []
    };
  },
  created() {},
  mounted() {},
  methods: {
    ...mapActions(["listDocuments", "openDocument"]),
    showDoc(index) {
      this.openDocument(this.userDocs[index]);
    }
  },
  computed: {
    ...mapGetters(["getUserStatus", "getAvailableDocuments"]),
    userState() {
      return this.getUserStatus;
    }
  },
  watch: {
    getAvailableDocuments: function() {
      this.userDocs = this.getAvailableDocuments;
      return this.userDocs;
    }
  }
};
</script>

<style scoped></style>
